import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { internalReportModuleURL } from 'src/services/urlService';
import { Box } from '@mui/material';
import { useToaster } from 'src/utils/toaster/toasterContext';
import ReportHttpServices from 'src/services/reportsHttpService';
import { useLocation } from 'react-router-dom';
import CustomScheduledReportBodyComponent from './custom-scheduled-report-body.component';

const CustomScheduledHeaderReportComponent = ({ customReportId, subReportId }) => {
  const location = useLocation();
  const { showToast } = useToaster();

  const urlParams = new URLSearchParams(location.search);
  const urlBrandId = urlParams.get('brand_id');
  const urlToken = urlParams.get('token');

  const [isLoading, setLoading] = useState(true);
  const [customReportData, setCustomReportData] = useState(null);

  useEffect(() => {
    if (customReportId) {
      getSubReports();
    }
  }, [customReportId]);

  const failureCallback = (message) => {
    setLoading(false);
    showToast(message, 'e');
    setCustomReportData(null);
  };

const successCallback = (data) => {
  const filteredReport = {
    ...data,
    report_cards: data?.report_cards?.filter(
      card => card.is_active === true && card.is_enabled === true
    ) || []
  };

  setCustomReportData(filteredReport);
  setLoading(false);
};


  const getSubReports = () => {
    setLoading(true);
    let getProps = {
      url: `${internalReportModuleURL.fetchCustomReport}${parseInt(customReportId)}`,
      brandId: urlBrandId,
      token: urlToken,
      successCallback,
      failureCallback,
    };
    ReportHttpServices.Get(getProps);
  };
  return (
    <Box id="fb-summary" sx={{ mt: 4 }}>
      {/* Only render SummaryComponent once the data is fetched */}
      {!isLoading && customReportData != null ? (
        <CustomScheduledReportBodyComponent customReportData={customReportData} subReportId={subReportId}/>
      ) : (
        isLoading && <Typography>Loading...</Typography>
      )}
    </Box>
  );
};

export default CustomScheduledHeaderReportComponent;
